<template>
    <x-modal :title="title"
             :visible="showDialog"
             :loading="loading"
             @open="handleOpen"
             @opened="opened"
             @close="clickNewSale"
             width="800px">
        <div class="row">
            <Keypress key-event="keyup" :key-code="13" @success="someMethod"/>
            <div class="col-12" v-if="responseDocument && responseDocument.message">
                <el-alert :title="responseDocument.message"
                          type="success"
                          :closable="false">
                </el-alert>
            </div>
            <div class="col-12 mt-2" v-if="responseSunat && responseSunat.message">
                <el-alert :title="responseSunat.message"
                          :type="`${responseSunat.success?'success':'error'}`"
                          :closable="false">
                </el-alert>
            </div>
            <div class="col-12 mt-4">
                <el-tabs v-model="activeName">
                    <el-tab-pane label="Imprimir A4" name="quarter">
                        <embed :src="form.print_a4" type="application/pdf" width="100%" height="450px"/>
                    </el-tab-pane>
                    <el-tab-pane label="Imprimir Ticket" name="first" v-if="configuration.show_ticket_80">
                        <embed :src="form.print_ticket" type="application/pdf" width="100%" height="450px"/>
                    </el-tab-pane>
                    <el-tab-pane label="Imprimir Ticket 58" name="second" v-if="configuration.show_ticket_58">
                        <embed :src="form.print_ticket_58" type="application/pdf" width="100%" height="450px"/>
                    </el-tab-pane>
                    <el-tab-pane label="Imprimir Ticket 50" name="third" v-if="configuration.show_ticket_50">
                        <embed :src="form.print_ticket_50" type="application/pdf" width="100%" height="450px"/>
                    </el-tab-pane>
                    <el-tab-pane label="Imprimir A5" name="fifth" v-if="configuration.show_a5">
                        <embed :src="form.print_a5" type="application/pdf" width="100%" height="450px"/>
                    </el-tab-pane>
                    <el-tab-pane label="Imprimir A5 V" name="fifth_v" v-if="configuration.show_a5_V">
                        <embed :src="form.print_a5_v" type="application/pdf" width="100%" height="450px"/>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <!--            <div class="col-12 mt-4">-->
            <!--                <div class="row">-->
            <!--                    <div class="col">-->
            <!--                        <x-button-pdf label="A4"-->
            <!--                                      color="btn-info"-->
            <!--                                      @click="clickPrint(form.print_ticket)"></x-button-pdf>-->
            <!--                    </div>-->
            <!--                    <div v-if="configuration && configuration.show_ticket_80" class="col">-->
            <!--                        <x-button-pdf label="Ticket"-->
            <!--                                      icon="fa-light fa-receipt"-->
            <!--                                      color="btn-info"-->
            <!--                                      @click="clickPrint(form.print_ticket)"></x-button-pdf>-->
            <!--                    </div>-->
            <!--                    <div v-if="configuration && configuration.show_ticket_58" class="col">-->
            <!--                        <x-button-pdf label="58mm"-->
            <!--                                      icon="fa-light fa-receipt"-->
            <!--                                      color="btn-info"-->
            <!--                                      @click="clickPrint(form.print_ticket_58)"></x-button-pdf>-->
            <!--                    </div>-->
            <!--                    <div v-if="configuration && configuration.show_ticket_50" class="col">-->
            <!--                        <x-button-pdf label="50mm"-->
            <!--                                      icon="fa-light fa-receipt"-->
            <!--                                      color="btn-info"-->
            <!--                                      @click="clickPrint(form.print_ticket_50)"></x-button-pdf>-->
            <!--                    </div>-->
            <!--                    <div v-if="configuration && configuration.show_a5" class="col">-->
            <!--                        <x-button-pdf label="A5"-->
            <!--                                      icon="fa-light fa-print"-->
            <!--                                      color="btn-info"-->
            <!--                                      @click="clickPrint(form.print_a5)"></x-button-pdf>-->
            <!--                    </div>-->
            <!--                    <div v-if="configuration && configuration.show_a5_v" class="col">-->
            <!--                        <x-button-pdf label="A5-V"-->
            <!--                                      icon="fa-light fa-print"-->
            <!--                                      color="btn-info"-->
            <!--                                      @click="clickPrint(form.print_a5_v)"></x-button-pdf>-->
            <!--                    </div>-->
            <!--                </div>-->
            <!--            </div>-->
            <div class="col-12 mt-4">
                <div class="row">
                    <div class="col-md-6">
                        <el-input v-model="form.customer_email" ref="ref_customer_email" @keyup.native="keyupCustomerEmail">
                            <el-button slot="append" icon="el-icon-message" @click="clickSendEmail" :loading="loading">Enviar</el-button>
                        </el-input>
                    </div>
                    <div class="col-md-6">
                        <el-input v-model="form.customer_telephone">
                            <template slot="prepend">+51</template>
                            <el-button slot="append" @click="clickSendWhatsapp">Enviar
                                <el-tooltip class="item" effect="dark" content="Es necesario tener aperturado Whatsapp web" placement="top-start">
                                    <i class="fab fa-whatsapp"></i>
                                </el-tooltip>
                            </el-button>
                        </el-input>
                    </div>
                </div>
            </div>
            <div class="col-md-12 btn-actions">
                <x-button-cancel @click="clickNewSale" text="Nueva venta"></x-button-cancel>
            </div>
        </div>

        <!--    <el-dialog :visible="showDialog" @open="create" @opened="opened" width="60%" :close-on-click-modal="false" :close-on-press-escape="false"-->
        <!--               :show-close="false">-->
        <!--        <span slot="title">-->
        <!--            <div class="widget-summary widget-summary-xs pl-3 p-2">-->
        <!--                <div class="widget-summary-col widget-summary-col-icon">-->
        <!--                    <div class="summary-icon bg-success">-->
        <!--                        <i class="fas fa-check"></i>-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--                <div class="widget-summary-col">-->
        <!--                    <div class="summary row">-->
        <!--                        <div class="col-md-6">-->
        <!--                            <h4 class="title">Venta exitosa : comprobante {{ form.number }}</h4>-->
        <!--                        </div>-->
        <!--                        <div class="col-md-6">-->
        <!--                            <h4 class="title">Envio automático: {{ (configuration.send_auto) ? 'Activado' : 'Desactivado' }}</h4>-->
        <!--                        </div>-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--        </span>-->
    </x-modal>
    <!--    </el-dialog>-->
</template>

<script>

import Keypress from 'vue-keypress'
import SaleNoteGenerate from '../../SaleNotes/partials/option_documents.vue'
import XModal from "../../../../components/XModal.vue";
import XButtonCancel from "../../../../components/Form/XButtonCancel.vue";
import XButtonPdf from "../../../../components/XButtonPdf.vue";

export default {
    props: ['showDialog', 'recordId', 'responseDocument', 'responseSunat', 'resource', 'fromPos'],
    components: {
        XButtonPdf,
        XButtonCancel,
        XModal,
        Keypress,
        SaleNoteGenerate
    },
    data() {
        return {
            title: null,
            loading: false,
            errors: {},
            form: {},
            company: {},
            configuration: {},
            activeName: 'quarter',
        }
    },
    async created() {
        this.initForm()
        await this.$http.get(`/configurations/record`)
            .then(response => {
                this.configuration = response.data.data
            })
    },
    methods: {
        initForm() {
            this.errors = {};
            this.form = {
                customer_email: null,
                download_pdf: null,
                print_a4: null,
                print_ticket: null,
                print_ticket_50: null,
                print_ticket_58: null,
                print_a5: null,
                print_a5_v: null,
                external_id: null,
                number: null,
                customer_telephone: null,
                message_text: null,
                id: null
            }
            this.activeName = 'quarter'
        },
        clickSendWhatsapp() {
            if (!this.form.customer_telephone) {
                return this.$message.error('El número es obligatorio')
            }
            window.open(`https://wa.me/51${this.form.customer_telephone}?text=${this.form.message_text}`, '_blank');
        },
        someMethod() {
            if (!this.showDialog) {
                return
            }
            const external_id = this.form.external_id
            let format = 'a4'
            switch (this.activeName) {
                case 'first':
                    format = 'ticket'
                    break;
                case 'second':
                    format = 'ticket_58'
                    break;
                case 'third':
                    format = 'ticket_50'
                    break;
                case 'quarter':
                    format = 'a4'
                    break;
                case 'fifth':
                    format = 'a5'
                    break;
                case 'fifth_v':
                    format = 'a5_v'
                    break;
            }
            if (this.resource === 'sale-notes') {
                window.open(`/sale-notes/downloadExternal/${external_id}/${format}`, '_blank');
            } else if (this.resource === 'documents') {
                if (format === 'ticket') {
                    window.open(`/downloads/Document/${type}/${external_id}/pdf`, '_blank');
                } else {
                    window.open(`downloads/documents/${type}/${external_id}/${format}`, '_blank');
                }
            }
        },
        keyupCustomerEmail(e) {
            if (e.keyCode === 9) {
                this.clickNewSale()
            }
        },
        initFocus() {
            this.$refs.ref_customer_email.$el.getElementsByTagName('input')[0].focus()
        },
        async clickNewSale() {
            if (this.configuration.refresh_pos) {
                location.reload()
            } else {
                await this.initForm()
                this.$emit('update:showDialog', false)
            }
        },
        async handleOpen() {
            this.initForm()
            this.changeActiveName()
            await this.$http.get(`/${this.resource}/record/${this.recordId}`)
                .then(response => {
                    this.form = response.data.data;
                    this.title = 'Comprobante: ' + this.form.number;
                })
        },
        opened() {
            this.initFocus()
        },
        async clickSendEmail() {
            if (this.form.customer_email == null || this.form.customer_email === '') return this.$message.error('Ingrese el correo')
            this.loading = true
            await this.$http.post(`/${this.resource}/email`, {
                customer_email: this.form.customer_email,
                id: this.form.id
            })
                .then(response => {
                    if (response.data.success) {
                        this.$message.success('El correo fue enviado satisfactoriamente')
                    } else {
                        this.$message.error('Error al enviar el correo')
                    }
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        this.errors = error.response.data.errors
                    } else {
                        this.$message.error(error.response.data.message)
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },
        clickPrint(url) {
            window.open(`${url}`, '_blank');
        },
        changeActiveName() {
            console.log('aaaaa')
            console.log(this.configuration)
            console.log('aaaaa')
            this.activeName = this.configuration.show_ticket_80 ? 'first' : 'quarter';
        }
    }
}
</script>
